import { useContext } from 'react';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';

export const useActiveSteps = (): number[] => {
    const { formData } = useContext(NestleFormWrapperContext);

    const isStep1Active =
        formData.photo &&
        formData.nickname.trim() &&
        formData.nickname2.trim() &&
        (formData.animal || formData.animalOther.trim()) &&
        formData.breed &&
        (formData.date || formData.dateUnknown);

    const isStep2Active = isStep1Active && formData.cardColor;
    const isStep3Active = formData.name.trim() && formData.email.trim();
    const isStep4Active = formData.promo && formData.nestleData && formData.newsletters && formData.vkData;

    const conditions = [isStep1Active, isStep2Active, isStep3Active, isStep4Active];

    return conditions.map((isActive, index) => (isActive ? index + 1 : 0)).filter(Boolean);
};
